var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBjs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-8{fill:#d2272c;}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7{fill-rule:evenodd;}.cls-2{fill:#332c2b;}.cls-3{fill:#e5252a;}.cls-4{fill:#d1272c;}.cls-5{fill:#bb292d;}.cls-6{fill:#9d272a;}.cls-7{fill:#8b2527;}.cls-9{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-3",
    "data-name": "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3.84,32.67a2.1,2.1,0,0,0,0,.37A1.57,1.57,0,0,0,5.4,34.25c1.06,0,1.69-.88,1.69-2.18,0-1.13-.57-2.11-1.65-2.11a1.63,1.63,0,0,0-1.55,1.27,2.42,2.42,0,0,0-.05.42v1Zm-1-6.05h1v3.56h0a2.07,2.07,0,0,1,1.9-1c1.38,0,2.36,1.17,2.35,2.9,0,2-1.26,3-2.5,3A2,2,0,0,1,3.74,34h0l0,.93H2.79c0-.38,0-1,0-1.46V26.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.32,32.05c-1.11,0-2.36.17-2.36,1.28a.9.9,0,0,0,.95,1,1.39,1.39,0,0,0,1.35-1,.92.92,0,0,0,.06-.33Zm1,1.53a8,8,0,0,0,.09,1.36h-.92l-.08-.71h0a2.07,2.07,0,0,1-1.7.84A1.6,1.6,0,0,1,9,33.44c0-1.37,1.19-2.12,3.35-2.11v-.11A1.17,1.17,0,0,0,11,29.9a2.72,2.72,0,0,0-1.45.43l-.23-.68a3.37,3.37,0,0,1,1.83-.51c1.7,0,2.12,1.19,2.12,2.32v2.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.93,30.81c0-.59,0-1.07,0-1.54h.9l.06.94h0a2,2,0,0,1,1.84-1.07c.78,0,2,.47,2,2.42v3.38h-1V31.67c0-.91-.33-1.67-1.29-1.67A1.45,1.45,0,0,0,16,31.05a1.73,1.73,0,0,0-.07.48v3.41h-1V30.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.32,31.87h0c.14-.2.34-.44.5-.64l1.63-2h1.22L23.54,31.6,26,34.94H24.76l-1.92-2.72-.52.59v2.13h-1V26.62h1v5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.07,27.63a.77.77,0,0,1-.83.77.76.76,0,0,1-.8-.77.78.78,0,0,1,.82-.79A.76.76,0,0,1,29.07,27.63Zm-3,8.67a1.58,1.58,0,0,0,1.1-.41c.27-.28.38-.74.38-2V29.22H29v5.1a3.22,3.22,0,0,1-.75,2.44,3.1,3.1,0,0,1-2,.67l-.15-1.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.61,32.14c-1,0-2,.2-2,1.07a.76.76,0,0,0,.83.82,1.2,1.2,0,0,0,1.15-.79,1.15,1.15,0,0,0,0-.31v-.79ZM35,33.56a9,9,0,0,0,.08,1.37H33.8l-.09-.63h0a2.16,2.16,0,0,1-1.71.76,1.71,1.71,0,0,1-1.82-1.7c0-1.44,1.3-2.17,3.44-2.16v-.09c0-.38-.16-1-1.18-1a3.1,3.1,0,0,0-1.56.43l-.28-.94a4.2,4.2,0,0,1,2.09-.51A2.15,2.15,0,0,1,35,31.5v2.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M38.19,27.76v1.46h1.39V30.3H38.19v2.52c0,.69.19,1.06.75,1.06a2.1,2.1,0,0,0,.57-.07l0,1.1a3.23,3.23,0,0,1-1.06.15,1.74,1.74,0,0,1-1.26-.48,2.32,2.32,0,0,1-.45-1.6V30.3h-.83V29.22h.83v-1l1.43-.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M40.69,34.93V29.22h1.47v5.71Zm1.55-7.3a.82.82,0,0,1-1.64,0,.82.82,0,0,1,1.64,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.73,30.92c0-.65,0-1.21,0-1.7h1.26l.06.85h0a2,2,0,0,1,1.78-1,1.67,1.67,0,0,1,1.6,1.06h0a2.22,2.22,0,0,1,.71-.72,2,2,0,0,1,1.17-.34c1,0,1.93.65,1.93,2.48v3.36H50.84V31.78c0-1-.34-1.51-1-1.51a1.11,1.11,0,0,0-1,.76,2.31,2.31,0,0,0-.07.48v3.42H47.28v-3.3c0-.8-.32-1.36-1-1.36a1.13,1.13,0,0,0-1,.82,1.17,1.17,0,0,0-.08.46v3.38H43.73v-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36.36,36.68s7.19,2.21,12.53,1,8.7-3.28,12.7-9.14c2.74-4,4-4.71,4-4.71a13.87,13.87,0,0,1-2.47,6.7c-2,2.68-3,4-3,4l-8.79,4.33s-4.77.9-14.88-2.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M41.64,38S47.13,39,54.3,36c2.58-1.11,3.55-1.59,8.76-5.52a56.39,56.39,0,0,1,5.69-3.62,14,14,0,0,1-4,5.13c-2.11,2-1.88,2.92-1.88,2.92l-9.35,3.28S50,39.09,41.64,38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47,38.06s2.27-.39,4.78-1.1a61.79,61.79,0,0,0,11.41-4.38,47,47,0,0,1,6-2.13,14.5,14.5,0,0,1-4.33,3.64,10.22,10.22,0,0,1-3,1.62l-4,1.36a28.45,28.45,0,0,1-11,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M46.55,37.83a9.18,9.18,0,0,0,3-.33c3.7-.76,7.29-1.63,10.73-2.66a30.48,30.48,0,0,1,6.93-1s-1.89,1-4.47,2.07a14.06,14.06,0,0,1-2.89.91l-4,.77a41.36,41.36,0,0,1-9.38.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M50,39.27a36.48,36.48,0,0,1-13.77-2.64,39,39,0,0,0,13.19.91c3.84-.5,6.88-1.24,10.22-1.6a30.39,30.39,0,0,1,5.48,0A37.8,37.8,0,0,1,50,39.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.41,44.78a2.58,2.58,0,0,0,1.28.38c.7,0,1-.35,1-.79s-.27-.72-1-1c-1-.34-1.41-.87-1.41-1.51a1.65,1.65,0,0,1,1.84-1.57,2.73,2.73,0,0,1,1.31.33l-.24.71A2.11,2.11,0,0,0,9.14,41c-.58,0-.9.33-.9.73s.32.64,1,.9c.92.35,1.4.82,1.4,1.61s-.73,1.6-2,1.6a3.08,3.08,0,0,1-1.5-.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M12.26,40.43l1.17,3.16c.12.35.25.77.34,1.09h0c.1-.32.21-.73.34-1.12l1.06-3.13h1l-1.45,3.81a8.25,8.25,0,0,1-1.83,3.34,2.63,2.63,0,0,1-1.19.62l-.24-.81a2.45,2.45,0,0,0,.84-.48,2.85,2.85,0,0,0,.82-1.08.79.79,0,0,0,.08-.23.73.73,0,0,0-.07-.25l-2-4.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M20,45.77l-.07-.67h0a2,2,0,0,1-1.63.79,1.52,1.52,0,0,1-1.63-1.53c0-1.29,1.15-2,3.21-2v-.11A1.1,1.1,0,0,0,18.63,41a2.57,2.57,0,0,0-1.39.4L17,40.79a3.28,3.28,0,0,1,1.75-.48c1.63,0,2,1.12,2,2.18v2a7.2,7.2,0,0,0,.09,1.28Zm-.14-2.72c-1.06,0-2.26.16-2.26,1.2a.85.85,0,0,0,.92.92,1.34,1.34,0,0,0,1.29-.89,1.12,1.12,0,0,0,.05-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M22.36,42.1c0-.63,0-1.17,0-1.67h.85l0,1h.05a1.59,1.59,0,0,1,1.47-1.17.82.82,0,0,1,.28,0v.91a1.61,1.61,0,0,0-.33,0,1.35,1.35,0,0,0-1.3,1.24,2.06,2.06,0,0,0-.05.45v2.85h-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.09,38.93a.6.6,0,1,1-1.2,0,.59.59,0,0,1,.61-.6A.57.57,0,0,1,27.09,38.93ZM26,45.77V40.43h1v5.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M31.54,45.77l-.07-.67h0a2,2,0,0,1-1.63.79,1.52,1.52,0,0,1-1.63-1.53c0-1.29,1.15-2,3.21-2v-.11A1.1,1.1,0,0,0,30.17,41a2.57,2.57,0,0,0-1.39.4l-.22-.64a3.28,3.28,0,0,1,1.75-.48c1.63,0,2,1.12,2,2.18v2a7.2,7.2,0,0,0,.09,1.28Zm-.14-2.72c-1.06,0-2.26.16-2.26,1.2a.85.85,0,0,0,.92.92,1.34,1.34,0,0,0,1.29-.89,1.12,1.12,0,0,0,0-.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M33.9,37.94h1v3.33h0a1.83,1.83,0,0,1,.7-.68,2,2,0,0,1,1-.28c.72,0,1.86.44,1.86,2.28v3.18h-1V42.7c0-.86-.32-1.58-1.23-1.58a1.39,1.39,0,0,0-1.3,1,1.06,1.06,0,0,0-.07.46v3.22h-1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    width: 72,
    height: 72
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBjs);
export default __webpack_public_path__ + "static/media/BJS.1214bce26ca99864c2c04cd645f38689.svg";
export { ForwardRef as ReactComponent };